"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumns = void 0;
const components_1 = require("@veeam/components");
require("../../../..");
const widgets_1 = require("../..");
const components_2 = require("../../../../../components");
require("../../../../../core");
const getColumns = (t, onPolicyClick) => [
    {
        id: widgets_1.TOP_POLICY_COLUMNS.name,
        title: t('dashboard|topPolicies|grid|column|policyName'),
        cell: components_2.cellRendererAdapter(widgets_1.TOP_POLICY_COLUMNS.name, components_2.linkCellRenderer({
            action: ({ rowData }) => {
                onPolicyClick(rowData.id, rowData.name, rowData.type);
            },
        })),
        width: 142,
    },
    {
        id: widgets_1.TOP_POLICY_COLUMNS.duration,
        title: t('dashboard|topPolicies|grid|column|duration'),
        justify: components_1.GRID_COLUMN_JUSTIFY.right,
        cell: components_2.cellRendererAdapter(widgets_1.TOP_POLICY_COLUMNS.duration, widgets_1.policyDurationCellRenderer()),
        width: 130,
    },
    {
        id: widgets_1.TOP_POLICY_COLUMNS.startTime,
        title: t('dashboard|topPolicies|grid|column|startTime'),
        width: 130,
        cell: components_2.cellRendererAdapter(widgets_1.TOP_POLICY_COLUMNS.startTime, components_2.datetimeCellRenderer({
            format: widgets_1.DATE_TIME_FORMAT,
        })),
    },
    {
        id: widgets_1.TOP_POLICY_COLUMNS.percentage,
        title: t('dashboard|topPolicies|grid|column|percentage'),
        justify: components_1.GRID_COLUMN_JUSTIFY.right,
        width: 110,
        cell: components_2.cellRendererAdapter(widgets_1.TOP_POLICY_COLUMNS.percentage, widgets_1.policyPercentageCellRenderer()),
    },
];
exports.getColumns = getColumns;
//# sourceMappingURL=getColumns.js.map